import { toast } from 'react-toastify';
import { Button } from 'primereact/button';

export const ToastWithTwoButtons = (
  text: string,
  onClickApprove: () => any | null,
  onClickReject: () => any | null,
) => {
  return toast(
    (props: { closeToast: () => void }) => (
      <div>
        <p>{text}</p>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          {onClickApprove && (
            <Button
              style={{ height: '30px' }}
              onClick={() => {
                onClickApprove();
                props.closeToast();
              }}
              label={'אישור'}
            />
          )}

          {onClickReject && (
            <Button
              style={{ height: '30px' }}
              onClick={() => {
                onClickReject();
                props.closeToast();
              }}
              outlined={true}
              label={'ביטול'}
            />
          )}
        </div>
      </div>
    ),
    { autoClose: false, closeOnClick: false },
  );
};
